module.exports = __webpack_public_path__ + "static/media/table-sort-icon.fe9b41ec.svg";